/* ============================================================
   THE ARK — interaction layer
   ============================================================ */
(function(){
  "use strict";
  var RM    = matchMedia("(prefers-reduced-motion:reduce)").matches;
  var TOUCH = matchMedia("(hover:none),(pointer:coarse)").matches;
  function $(s,c){return (c||document).querySelector(s);}
  function $all(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function money(cents){return "Rs " + Math.round(cents/100).toLocaleString("en-US");}

  document.addEventListener("DOMContentLoaded", function(){

    /* ---- sticky header shadow ---- */
    var header = $("header");
    if(header){
      var onScroll=function(){ header.classList.toggle("scrolled", window.scrollY>10); };
      onScroll(); addEventListener("scroll", onScroll, {passive:true});
    }

    /* ---- shared scrim ---- */
    var scrim = document.createElement("div");
    scrim.className = "scrim";
    document.body.appendChild(scrim);
    function lock(on){ document.body.style.overflow = on ? "hidden" : ""; }

    /* ---- mobile menu ---- */
    var toggle = $(".mobile-toggle"), menu = $(".mobile-menu");
    if(menu) document.body.appendChild(menu); // lift out of blurred <header> so fixed sizing works
    function openMenu(){ if(!menu)return; menu.hidden=false; scrim.classList.add("on"); lock(true); }
    function closeMenu(){ if(!menu)return; menu.hidden=true; if(!drawerOpen())scrim.classList.remove("on"); lock(drawerOpen()); }
    if(toggle && menu){
      toggle.addEventListener("click", function(){ menu.hidden ? openMenu() : closeMenu(); });
      var mc = $(".menu-close", menu);
      if(mc) mc.addEventListener("click", closeMenu);
      $all("a", menu).forEach(function(a){ a.addEventListener("click", closeMenu); });
    }

    /* ---- announcement rotator ---- */
    $all("[data-announcement-bar]").forEach(function(bar){
      var items = $all(".announcement-item", bar);
      if(items.length < 2) return;
      var i=0, speed=(parseInt(bar.dataset.speed,10)||4)*1000;
      setInterval(function(){ items[i].classList.remove("active"); i=(i+1)%items.length; items[i].classList.add("active"); }, speed);
    });

    /* ---- scroll reveals ---- */
    if(!RM && "IntersectionObserver" in window){
      var groups = [".section-head",".prod-card",".coll-card",".cat-card",".trust-card",
                    ".testi-card",".story-visual",".story-text",".promo .wrap",".wa-cta",".content-box",
                    ".product-gallery",".coll-header",".page-head",".cart-line",".contact-wrap"];
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add("in"); io.unobserve(en.target); } });
      }, {threshold:.12, rootMargin:"0px 0px -8% 0px"});
      groups.forEach(function(sel){ $all(sel).forEach(function(el){ el.setAttribute("data-reveal",""); }); });
      $all("[data-reveal]").forEach(function(el,i){
        el.style.transitionDelay = Math.min(i%4*0.07, .21) + "s";
        io.observe(el);
      });
    }

    /* ---- magnetic buttons ---- */
    if(!TOUCH){
      $all("[data-magnetic]").forEach(function(el){
        el.addEventListener("pointermove", function(e){
          var r=el.getBoundingClientRect();
          el.style.transform="translate("+((e.clientX-r.left-r.width/2)*.25)+"px,"+((e.clientY-r.top-r.height/2)*.4)+"px)";
        });
        el.addEventListener("pointerleave", function(){
          el.style.transition="transform .4s cubic-bezier(.16,1,.3,1)";
          el.style.transform="";
          setTimeout(function(){ el.style.transition=""; }, 400);
        });
      });
    }

    /* ---- product / collection card tilt ---- */
    function bindTilt(scope){
      if(TOUCH) return;
      $all(".prod-card, .coll-card", scope).forEach(function(el){
        if(el._tilt) return; el._tilt=1;
        el.addEventListener("pointermove", function(e){
          var r=el.getBoundingClientRect();
          var rx=((e.clientY-r.top)/r.height-.5)*-6, ry=((e.clientX-r.left)/r.width-.5)*6;
          el.style.transform="translateY(-6px) perspective(900px) rotateX("+rx+"deg) rotateY("+ry+"deg)";
        });
        el.addEventListener("pointerleave", function(){ el.style.transform=""; });
      });
    }
    bindTilt(document);
    /* cards injected later (filters, pagination) get the same tilt + are revealed immediately */
    document.addEventListener("ark:content", function(e){
      var scope=(e.detail&&e.detail.root)||document;
      $all("[data-reveal]", scope).forEach(function(el){ el.classList.add("in"); });
      bindTilt(scope);
    });

    /* ---- custom cursor ---- */
    if(!TOUCH){
      var cur=document.createElement("div"); cur.className="cursor"; document.body.appendChild(cur);
      var cx=innerWidth/2, cy=innerHeight/2, px=cx, py=cy;
      addEventListener("pointermove", function(e){ cx=e.clientX; cy=e.clientY; });
      (function cl(){ px+=(cx-px)*.22; py+=(cy-py)*.22;
        cur.style.transform="translate("+px+"px,"+py+"px) translate(-50%,-50%)"; requestAnimationFrame(cl); })();
      document.addEventListener("pointerover", function(e){
        cur.classList.toggle("big", !!e.target.closest("a,button,[data-magnetic],.prod-card,.coll-card,.add-btn"));
      });
    }

    /* ============ CART DRAWER + AJAX ============ */
    var drawer = document.createElement("aside");
    drawer.className = "cart-drawer";
    drawer.setAttribute("aria-hidden","true");
    drawer.innerHTML =
      '<div class="cd-head"><h3>Your bag</h3><button class="cd-close" aria-label="Close">✕</button></div>'+
      '<div class="cd-items"></div>'+
      '<div class="cd-foot"><div class="cd-sub"><span class="l">Subtotal</span><span class="n cd-total">Rs 0</span></div>'+
      '<p class="cd-note">Shipping & taxes calculated at checkout.</p>'+
      '<a class="btn btn-primary full-btn" href="/checkout"><span>Checkout</span><span class="arw">→</span></a></div>';
    document.body.appendChild(drawer);

    var toast = document.createElement("div");
    toast.className = "toast";
    toast.innerHTML = '<span class="dot"><svg viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5"/></svg></span><span class="toast-txt">Added to bag</span>';
    document.body.appendChild(toast);
    var toastTimer;
    function showToast(msg){
      $(".toast-txt",toast).textContent = msg;
      toast.classList.add("show");
      clearTimeout(toastTimer);
      toastTimer=setTimeout(function(){ toast.classList.remove("show"); }, 2400);
    }

    function drawerOpen(){ return drawer.classList.contains("on"); }
    function openDrawer(){ drawer.classList.add("on"); scrim.classList.add("on"); lock(true); }
    function closeDrawer(){ drawer.classList.remove("on"); if(menu&&!menu.hidden)return; scrim.classList.remove("on"); lock(false); }
    $(".cd-close",drawer).addEventListener("click", closeDrawer);
    scrim.addEventListener("click", function(){ closeDrawer(); closeMenu(); });
    addEventListener("keydown", function(e){ if(e.key==="Escape"){ closeDrawer(); closeMenu(); } });

    function setCount(n){
      var wrap=$(".cart-wrap"); if(!wrap)return;
      var badge=$(".cart-count",wrap);
      if(!badge){ badge=document.createElement("span"); badge.className="cart-count"; wrap.appendChild(badge); }
      badge.textContent=n; badge.style.display=n>0?"":"none";
      badge.classList.remove("bump"); void badge.offsetWidth; if(n>0) badge.classList.add("bump");
    }

    function renderCart(cart){
      var box=$(".cd-items",drawer);
      if(!cart.items.length){
        box.innerHTML='<div class="cd-empty"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.4"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your bag is empty.</p></div>';
      } else {
        box.innerHTML = cart.items.map(function(it){
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,"_120x$1$2") : "";
          var variant = (it.variant_title && it.variant_title!=="Default Title") ? '<div class="v">'+it.variant_title+'</div>' : "";
          return '<div class="cd-item" data-key="'+it.key+'">'+
            (img?'<img src="'+img+'" alt="">':'<div></div>')+
            '<div><div class="t">'+it.product_title+'</div>'+variant+
              '<div class="cd-qty"><button data-dec aria-label="Decrease">−</button><span>'+it.quantity+'</span><button data-inc aria-label="Increase">+</button></div></div>'+
            '<div><div class="p">'+money(it.final_line_price)+'</div><button class="cd-remove" data-remove>Remove</button></div>'+
          '</div>';
        }).join("");
      }
      $(".cd-total",drawer).textContent = money(cart.total_price);
      setCount(cart.item_count);
    }

    function refresh(open){
      return fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();})
        .then(function(cart){ renderCart(cart); if(open) openDrawer(); return cart; });
    }

    function change(key, qty){
      return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart);
    }

    drawer.addEventListener("click", function(e){
      var row=e.target.closest(".cd-item"); if(!row)return;
      var key=row.dataset.key, qtyEl=$(".cd-qty span",row), q=parseInt(qtyEl.textContent,10);
      if(e.target.closest("[data-inc]")) change(key,q+1);
      else if(e.target.closest("[data-dec]")) change(key,q-1);
      else if(e.target.closest("[data-remove]")) change(key,0);
    });

    /* open drawer from header cart icon */
    var cartLink=$(".cart-wrap");
    if(cartLink){ cartLink.addEventListener("click", function(e){ e.preventDefault(); refresh(true); }); }

    /* intercept add-to-cart forms */
    document.addEventListener("submit", function(e){
      var form=e.target;
      if(!form || !form.action || form.action.indexOf("/cart/add")===-1) return;
      e.preventDefault();
      var btn=form.querySelector('[type=submit]');
      if(btn){ btn.classList.add("added"); }
      var fd=new FormData(form);
      fetch("/cart/add.js",{method:"POST",headers:{"Accept":"application/json"},body:fd})
        .then(function(r){ if(!r.ok) throw r; return r.json(); })
        .then(function(item){
          showToast((item.product_title||"Item")+" added to bag");
          return refresh(true);
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if(btn) setTimeout(function(){btn.classList.remove("added");},1200); });
    });

    /* prime the count on load */
    refresh(false);

    /* ---- legacy hero slider (kept for safety if used) ---- */
    $all("[data-hero-slider]").forEach(function(hero){
      var track=$(".hero-slides",hero), slides=$all(".hero-slide",hero);
      if(!track||slides.length<2)return;
      var dots=$all(".hero-dot",hero), total=slides.length, index=0;
      function goTo(i){ index=(i+total)%total; track.style.transform="translateX(-"+(index*100)+"%)";
        dots.forEach(function(d,di){ d.classList.toggle("active",di===index); }); }
      var pv=$(".hero-prev",hero), nx=$(".hero-next",hero);
      if(pv)pv.addEventListener("click",function(){goTo(index-1);});
      if(nx)nx.addEventListener("click",function(){goTo(index+1);});
      dots.forEach(function(d){ d.addEventListener("click",function(){ goTo(parseInt(d.dataset.slideTo,10)); }); });
    });
  });
})();
